// extracted by mini-css-extract-plugin
export default {"container":"IntegrationNotice_container__QpyzG","badge":"IntegrationNotice_badge__5RkJi","title":"IntegrationNotice_title__Tecz4","message":"IntegrationNotice_message__JEA9I"};